import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../service/auth.service';
import { AdminBookingsService } from '../service/admin-bookings.service';

@Component({
  selector: 'app-bulk-booking-confirmation',
  templateUrl: './bulk-booking-confirmation.component.html',
  styleUrls: ['./bulk-booking-confirmation.component.css']
})
export class BulkBookingConfirmationComponent {

  firstName = '';
  lastName = '';
  email = '';
  phone = '';
  notes = '';

  paymentMethod = 'cash';
  paymentOption = 'anytime';

  expiryInDays = '0';
  expiryInMin = '30';

  totalAmount = 0;
  totalSlots = 0;
  unavailableSlots:any[] = [];
  isBookingInProgress = false;

  constructor(
    private authService: AuthService,
    public dialogRef: MatDialogRef<BulkBookingConfirmationComponent>,
    private adminBookingSvc: AdminBookingsService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    this.data.slots = this.getSlotsInChronologicalOrder(data.slots);

    this.totalSlots = data.slots.length;

    this.totalAmount =
      data.slots.reduce(
        (sum, slot) => sum + slot.price,
        0
      );

  }

  private getSlotsInChronologicalOrder(slots: any[]): any[] {

    return [...slots].sort(
      (firstSlot, secondSlot) =>
        this.getSlotSortTime(firstSlot)
        - this.getSlotSortTime(secondSlot)
    );

  }

  private getSlotSortTime(slot: any): number {

    const uniqueIdParts = slot.uniqueId.split('_');
    const slotDate = uniqueIdParts[2];
    const startTime =
      slot.startTime ||
      uniqueIdParts[3] ||
      '00:00';

    return new Date(
      `${slotDate} ${startTime}`
    ).getTime();

  }

  isUnavailable(uniqueId: string) {

    return this.unavailableSlots.some(
      slot =>
        slot.uniqueId === uniqueId &&
        slot.bookingStatus === 'Unavailable'
    );

  }


  removeSlot(uniqueId: string) {

    this.data.slots =
      this.data.slots.filter(
        slot => slot.uniqueId !== uniqueId
      );

    this.unavailableSlots =
      this.unavailableSlots.filter(
        slot => slot.uniqueId !== uniqueId
      );

    this.totalSlots = this.data.slots.length;

    this.totalAmount =
      this.data.slots.reduce(
        (sum, slot) => sum + slot.price,
        0
      );

  }

  getShortDate(uniqueId: string): string {

    const date = new Date(uniqueId.split('_')[2]);

    return date.toLocaleDateString(
      'en-US',
      {
        weekday: 'short',
        day: '2-digit',
        month: 'short'
      }
    );

  }
  confirmBooking() {

    let generatePaymentLink =
      this.paymentMethod === 'sendLink';

    let expiryDuration = -1;

    if (
      generatePaymentLink &&
      this.paymentOption === 'within'
    ) {

      expiryDuration =
        (Number(this.expiryInDays) * 24 * 60)
        + Number(this.expiryInMin);

    }

    let bookingArray = [];

    this.data.slots.forEach(slot => {

      bookingArray.push({

        uniqueId: slot.uniqueId,

        amount: slot.price,

        paymentType:
          generatePaymentLink ?
            'Billdesk' :
            'Cash',

        name:
          this.firstName +
          ' ' +
          this.lastName,

        email: this.email,

        phone: this.phone,

        notes: this.notes

      });

    });
    this.isBookingInProgress = true;
    this.authService.confirmBooking(
      bookingArray,
      generatePaymentLink,
      expiryDuration
    )
    .subscribe(

      (response: any) => {

        this.isBookingInProgress = false;
        console.log(response);

        // Booking successful
        if (
          !Array.isArray(response)
        ) {

          this.adminBookingSvc.reloadData.next({ reloadData: true });

          this.dialogRef.close({
            bookingId: response.confirmationId
          });

          return;

        }

        // Some slots are unavailable
        if (
          response.length > 0
        ) {

          this.unavailableSlots = response;

          alert(
            'Some slots are no longer available. Please remove them and confirm again.'
          );

        }

      },

      error => {
         this.isBookingInProgress = false;
         console.log(error);

          if (
              error.error &&
              Array.isArray(error.error)
          ) {

              this.unavailableSlots = error.error;

              alert(
                  'Some slots are no longer available. Please remove them and confirm again.'
              );

          }
          else {

              alert('Booking failed.');

          }
      }

    );

  }

  isValidEmail(): boolean {

    if (!this.email) {
      return false;
    }

    const emailRegex =
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    return emailRegex.test(
      this.email.trim()
    );

  }

  isValidPhone(): boolean {

    return /^[0-9]{10}$/.test(
      this.phone.trim()
    );

  }

  canConfirmBooking(): boolean {

    return (
      this.firstName.trim().length > 0
      &&
      this.lastName.trim().length > 0
      &&
      this.isValidEmail()
      &&
      this.isValidPhone()
    );

  }

  /* confirmBooking() {

    let generatePaymentLink =
      this.paymentMethod === 'sendLink';

    let expiryDuration = -1;

    if (
      generatePaymentLink &&
      this.paymentOption === 'within'
    ) {

      expiryDuration =
        (Number(this.expiryInDays) * 24 * 60)
        + Number(this.expiryInMin);

    }

    let bookingArray = [];

    this.data.slots.forEach(slot => {

      bookingArray.push({

        uniqueId: slot.uniqueId,

        amount: slot.price,

        paymentType:
          generatePaymentLink ?
            'Billdesk' :
            'Cash',

        name:
          this.firstName +
          ' ' +
          this.lastName,

        email: this.email,

        phone: this.phone,

        notes: this.notes

      });

    });

    this.authService.confirmBooking(
      bookingArray,
      generatePaymentLink,
      expiryDuration
    )
    .subscribe(

      (response: any) => {

        if (response && response.length > 0) {

          this.unavailableSlots = response;

          alert(
            'Some slots are no longer available. Please remove them and confirm again.'
          );

        } else {

          this.dialogRef.close({
            bookingId: response.confirmationId
          });

        }

      }

      error => {

        alert(
          'Booking failed.'
        );

      }

    );

  } */

  cancel() {

     // this.adminBookingSvc.clearSelectedSlots();

      this.dialogRef.close();

  }

}
